<template>
  <div>
    <el-dialog title="选择"
               :visible.sync="dialogVisible"
               :close-on-click-modal="false"
               :modal='false'
               :before-close="handleClose">
      <el-form :model="form"
               size="medium"
               ref="formRef"
               label-width="100rem">
 
        <el-form-item prop="discuss_title">
          <div class="text"> 您要生成的科目</div>
          <!-- <el-checkbox v-model="checkAll"
                       @change="handleCheckAllChange">全选</el-checkbox> -->
          <el-checkbox-group v-model="checkedCitiesOpt" :max="1">
            <el-checkbox v-for="city in cityOptions"
                         :label="city.subject_name"
                         :key="city.id">{{city.subject_name}}</el-checkbox>
          </el-checkbox-group>

          <!-- <el-checkbox v-model="has_source">包含题目来源</el-checkbox> -->
          <div class="text1">
            <div>您要分析的时间段</div> 
            <div class="text2">系统默认近两个月来的分析及对比。您可以根据自己的做卷情况和想要对比的时间段选择要分析的时间段（本次时间）和需要对比的时间段（上次时间）。
<br>注意：选择的本次时间段内必须有套卷训练数据才可生成分析报告！</div>
            <div class="text3">本次时间
              <!-- <el-date-picker  
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            style="margin-left: 16rem;width:80%"
                            v-model="value1"
                            :default-time="['00:00:00', '23:59:59']"
                            range-separator="~"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">

            </el-date-picker> -->
              <el-date-picker
      v-model="value1"
      type="datetime"
       value-format="yyyy-MM-dd HH:mm:ss"
       :picker-options="v1Opt"
      placeholder="选择日期时间">
    </el-date-picker>
      <el-date-picker
      v-model="value2"
      style="margin-left: 30rem;"
      type="datetime"
      :picker-options="v2Opt"
        value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期时间">
    </el-date-picker>
            
            </div>
            <div class="text3">上次时间
              <!-- <el-date-picker v-model="value2"
                              style="margin-left: 16rem;width:80%"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            :default-time="['00:00:00', '23:59:59']"
                            range-separator="~"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions1">
            </el-date-picker> -->
              <el-date-picker
      v-model="value3"
      type="datetime"
       :picker-options="v3Opt"
        value-format="yyyy-MM-dd HH:mm:ss"
      placeholder="选择日期时间">
    </el-date-picker>
      <el-date-picker
      v-model="value4"
        :picker-options="v4Opt"
        value-format="yyyy-MM-dd HH:mm:ss"
            style="margin-left: 30rem;"
      type="datetime"
      placeholder="选择日期时间">
    </el-date-picker>
            </div>
          </div>
          <div class="text" v-if="has_explain == 1">
            <div class="text_line">推送薄弱考点数
              <el-input-number v-model="point_num"
                               style="margin-left: 16rem;margin-bottom: 16rem;"
                               :min="1"
                               size="small"
                               :max="10"
                               label="推送薄弱考点数"></el-input-number>
            </div>
            <div class="text_line">各考点推送题目数量
              <el-input-number v-model="question_num"
                               style="margin-left: 16rem;"
                               :min="1"
                               :max="20"
                               size="small"
                               label="各考点推送题目数量"></el-input-number>
            </div>
          </div>
         
          <!-- <div class="btn_warp">
            <div @click="handleClose">取消</div>
            <div @click="exportBtn">导出</div>
          </div> -->
        </el-form-item>
        <div class="btn_warp">
          <div @click="handleClose">取消</div>
          <div @click="exportBtn">导出</div>
        </div>
      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import { getExplainReport } from '@/api/home.js'
import { getStudentSubject } from '@/api/subject.js'
import { saveAs } from "file-saver"
import { getNewReport } from '@/api/analysis.js'

export default {
  data () {
    return {
      dialogVisible: false,
      cityOptions: [],
      form: {
      },
      value1: '',
      value2: '',
      value3: '',
      value4: '',
      pickerOptions: {

      },
      pickerOptions1: {

      },
      has_explain: 1,
      checkAll: false,
      checkedCities: [],
      checkedCitiesOpt: [],
      select_all: 0,
      question_num: 5,
      point_num: 5,
      has_source: false,
      invite_code:'',
    }
  },
 computed: {
v3Opt() {
  const self = this
  return {
    disabledDate(time) {
      if (!self.value4) return false
      // 只要日期 ≥ value1 当天（含当天）全部禁用
      const startDay = new Date(self.value4).setHours(0, 0, 0, 0)
      return time.getTime() >= startDay
    }
  }
},
v4Opt() {
  const self = this
  return {
    disabledDate(time) {
      if (!self.value1) return false
      // 只要日期 ≥ value1 当天（含当天）全部禁用
      const startDay = new Date(self.value1).setHours(0, 0, 0, 0)
      const endDay = new Date(self.value3).setHours(0, 0, 0, 0)
      return time.getTime() >= startDay ||  time.getTime() < endDay
    }
  }
},
    v1Opt() {
      return {
        disabledDate: time => {
          if (!this.value2) return false
          return time.getTime() > new Date(this.value2).getTime() || time.getTime() < new Date(this.value4).getTime()
        }
      }
    },
    v2Opt() {
      return {
        disabledDate: time => {
          if (!this.value1) return false
          return time.getTime() < new Date(this.value1).getTime()
        }
      }
    }},
  async created () {
   let date1 = this.getRangeTime(30, 0)
   
    this.value1 =date1[0]
    this.value2 =date1[1]
 let date2 = this.getRangeTime(60, 31)
    this.value3 = date2[0]
      this.value4 = date2[1]
    this.nickname = JSON.parse(window.localStorage.getItem('userInfo')).nickname
    const { data } = await getStudentSubject()
    let totalScore = 0; // 定义变量用于累加分数
    let subjectListData = [];
    subjectListData = data.list.filter(item => item.subject_id !== 13).map(item => {
      totalScore += item.score;

      // if ((item.subject_id === 7 || item.subject_id === 12 || item.subject_id === 11) && item.score == 0) {
      //   item.score = 130; // 设置为130
      // } else if (item.score == 0) {
      //   item.score = 90; // 其他设为90
      // }

      return {
        subject_id: item.subject_id,
        score: item.score,
      }
    });
    this.$EventBus.emit('totalScoreEdit', totalScore)
    window.localStorage.setItem('subjectListData', JSON.stringify(subjectListData))
    window.localStorage.setItem('totalScore', totalScore)
    this.cityOptions = data.list.map(item => {
      return {
        subject_id: item.subject_id,
        subject_name: item.subject_name,
      }
    });
    this.getSystemName();
  },
  methods: {
    getSystemName () {

      const fullUrl = window.location.href;
      const domain = fullUrl.split("#")[0]; //去掉#及其后面的部分

      this.$http({
        url: '/api/v1/getSchollBrand',
        method: 'get',
        params: {
          brand_url: domain
        }
      }).then(res => {
        if (res.data.list.is_brand == '1') {
          this.invite_code = res.data.list.invite_code;
        }

      })
      console.log(this.invite_code) // 打印域名

    },
    getRangeTime (start, end) {
      let arr = []
      let startTime = new Date()
      let endTime = new Date()
      let n = startTime.getTimezoneOffset() //时差
      arr[0] = new Date(startTime - 3600 * 1000 * 24 * start - n * 60 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')
      arr[1] = new Date(endTime - 3600 * 1000 * 24 * end - n * 60 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '')

      return arr
    },
    handleCheckAllChange (val) {
      this.checkAll = val;
      if (val) {
        this.cityOptions.forEach(item => {
          this.checkedCitiesOpt.push(item.subject_name)
        })
        this.select_all = 1
      } else {
        this.checkedCitiesOpt = []
        this.select_all = 0
      }
    },
    handleClose () {
      this.dialogVisible = false
      this.$refs.formRef.resetFields()
    },
    exportBtn () {
      console.log('this.checkedCitiesOpt', this.checkedCitiesOpt)
      let exportArr = []
      this.cityOptions.forEach(element => {
        this.checkedCitiesOpt.forEach(item => {
          if (element.subject_name == item) {
            exportArr.push(element)
          }
        })
      });
      exportArr.forEach(item => {
        this.postExport(item.subject_id, item.subject_name)
      })
      this.handleClose()

    },
    base64ToBlob (base64) {
      const byteCharacters = atob(base64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: 'application/octet-stream' });
    },
    async postExport (subject_id, subject_name) {

      this.$parent.btnDisabled = true

      await getNewReport({
        show_question: this.has_explain,
        subject_id,
        // select_all: this.select_all,
        point_num: this.point_num,
        question_num: this.question_num,
        first_begin_time: this.value1,
        first_end_time: this.value2,
        second_begin_time: this.value3,
        second_end_time: this.value4,
        invite_code: this.invite_code,
      }).then(res => {
        if(res.data.code ==  40022003){
  
      this.$alert(
  '您所选时间段内未有对应训练数据记录，建议您尝试以下操作:<br>1.修改时间段<br>2.去训练后再来生成~',
  '温馨提示',
 
  {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '知道了' ,
     
  }
);
      return
} else if(res.data.code ==  40022002 || res.data.code ==  40022001){
   
      this.$alert(
  '根据您所选时间段内的训练记录，没有发现薄弱点，建议您尝试以下操作:<br>1.修改时间段<br>2.去增加训练数量！',
  '温馨提示',
 
  {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '知道了' ,
     
  }
);
      return
}else if(res.data.code == 0){
    this.$confirm("生成过程中出现错误，请点击下方按钮继续生成~", "提示", {
        confirmButtonText: "继续生成",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
       this.exportBtn()
      }).catch(() => { 
           this.dialogVisible = true
      })
      return
}
        const a = document.createElement("a")
        const blob = this.base64ToBlob(res.data.data)
        console.log('blob', blob)
        a.href = window.URL.createObjectURL(blob)

 
        if (this.checkAll) {
          if (this.has_explain == 1) {

            a.download = `${this.nickname}${subject_name}定制学案.pdf`
            a.click()
          } else {
           
            a.download = `${this.nickname}${subject_name}学情分析.pdf`
            a.click()

          }
        } else {
          if (this.has_explain == 1) {
            a.download = `${this.nickname}${subject_name}定制学案.pdf`
            a.click()
          } else {
            
        a.download = `${this.nickname}${subject_name}学情分析.pdf`
            a.click()
          }
        }
        this.$parent.btnDisabled = false


      })


      // const data = await getExplainReport({ has_explain: this.has_explain, subject_id, select_all: this.select_all })
      // if (data.size > 0) {
      //   this.$parent.btnDisabled = false
      // }
      // let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      // if (this.checkAll) {
      //   if (this.has_explain == 1) {
      //     saveAs(blob, `${subject_name}定制学案.docx`)
      //   } else {
      //     saveAs(blob, `${subject_name}题集.docx`)
      //   }
      // } else {
      //   if (this.has_explain == 1) {
      //     saveAs(blob, `${subject_name}定制学案.docx`)
      //   } else {
      //     saveAs(blob, `${subject_name}题集.docx`)
      //   }
      // }

    }
  }
}
</script>

<style lang="scss" scoped>
.text_warp {
  word-break: break-all;
  font-weight: 500;
  color: #666666 !important;
  line-height: 23rem;
  font-size: 16rem;
  // padding: 27rem;
  padding-top: 0;
}
.text {
  display: flex;
  flex-direction: column;
  font-size: 20rem;
  color: var(--light-333333, #333);
 margin-top:32rem;
 
font-style: normal;
font-weight: 600;
line-height: 30px; /* 150% */
.text_line{
  display: flex;
    justify-content: space-between;
    width: 95%;
}
}
.text1 {
  display: flex;
  flex-direction: column;
  font-size: 20rem;
  color: var(--light-333333, #333);
 gap:16rem;
 
font-style: normal;
font-weight: 600;
line-height: 30px; /* 150% */
.text2{
  color: var(--light-999999, #999);
  width: 96%;
font-size: 16rem;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}
.text3{
  color: var(--light-333333, #333);
  font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
}
}
.btn_warp {
  width: 720rem;
  height: 62rem;
  border-top: 1rem solid #eeeeee;
  display: flex;
  border-radius: 0rem 0rem 0rem 0rem;
  opacity: 1;
  align-items: center;
  justify-content: center;

  div {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    // font-size: 24rem;
    &:nth-child(1) {
      width: 40rem;
      height: 60rem;
      font-size: 20rem;

      font-weight: 400;
      border-right: 1rem solid #eeeeee;
      color: #333333;

      line-height: 30rem;
      -webkit-background-clip: text;
    }
    &:nth-child(2) {
      width: 40rem;
      height: 30rem;

      font-size: 20rem;

      font-weight: 400;
      color: #2196f3;
      line-height: 30rem;
      -webkit-background-clip: text;
    }
  }
}
::v-deep .el-checkbox__inner::after {
  height: 15rem;
  left: 7rem;
  width: 5rem;
  box-sizing: content-box;
  content: "";
  border: 2px solid #fff;
  border-left: 0;
  border-top: 0;

  position: absolute;
  top: 1px;
  transform: rotate(45deg) scaleY(0);

  transition: transform 0.15s ease-in 0.05s;
  transform-origin: center;
}
::v-deep .el-dialog__body {
  padding: 0rem !important;
  flex-wrap: wrap-reverse;
  display: flex;
  max-width: 790rem;
  margin-top: 4rem;
}

::v-deep .el-dialog__header {
  text-align: center;
  padding-left: 288rem;
  padding-top: 30rem;
  width: 144rem;
  height: 36rem;
  font-size: 24rem;

  font-weight: 500;
  color: #333333;
  line-height: 36rem;
  -webkit-background-clip: text;
}
::v-deep .el-dialog {
  border-radius: 10rem;
  width: 720rem;
  height: auto;
  background: #ffffff;
  border-radius: 24rem 24rem 24rem 24rem;
  opacity: 1;
}

::v-deep .el-textarea__inner {
  font-size: 16rem;
}
::v-deep .el-form-item__content {
  margin-left: 37rem !important;
}

::v-deep .el-input__inner {
  // height: 45rem;
  line-height: 45rem;
  font-size: 16rem;
}
::v-deep .el-checkbox__input {
  padding-top: 4rem;
}
::v-deep .el-form-item__label {
  line-height: 45rem;
  font-size: 18rem;
}
::v-deep .el-dialog__headerbtn .el-dialog__close {
  display: none;
}
::v-deep .el-dialog__title {
  width: 144rem;
  height: 36rem;
  font-size: 24rem;

  font-weight: 600;
  color: #333333;
  line-height: 36rem;
  -webkit-background-clip: text;
}

::v-deep .el-checkbox-group {
  text-align: left; //这个很关键，否则最后一行是居中状态
}
::v-deep .el-checkbox__inner {
  width: 23rem;
  height: 23rem;
}
::v-deep .el-checkbox__label {
  font-size: 20rem;
  padding-left: 8rem;
}
::v-deep .el-checkbox {
  // margin-left: 20rem !important;
  margin-right: 39rem;
  // width: 72rem; //根据内容设置宽度
  height: 30rem;
  // padding-left: 0rem;
  font-size: 20rem;
  margin-bottom: 24rem;
  text-align: left; //这个很关键，否则每一行都是居中状态
}
</style>